import { styled } from "styled-components";

import { CROSS_SELL_ANIMATION_DURATION_MS } from "./constants";

/** Animates open/closed height via grid-template-rows. */
export const CrossSellOuterGrid = styled.div<{ $gridRows: string }>(({ $gridRows }) => ({
    display: "grid",
    gridTemplateRows: $gridRows,
    transition: `grid-template-rows ${CROSS_SELL_ANIMATION_DURATION_MS}ms ease-in-out`,
}));

/**
 * minHeight:0 lets the grid row collapse fully. overflow-x:visible keeps full-width breakout.
 * overflow-y:clip clips vertical overflow during animation without a scroll container (which would block overflow-x).
 */
export const CrossSellClipLayer = styled.div({
    minHeight: 0,
    overflowX: "visible",
    overflowY: "clip",
});

export const CrossSellBreakoutRow = styled.div({
    width: "100vw",
    maxWidth: "100vw",
    marginLeft: "-16px",
    marginTop: "12px",
});

export const StyledTopHandle = styled.div({
    display: "flex",
    justifyContent: "flex-start",
    paddingLeft: "calc(100vw - 128px + 32px)",
});

// A solid filled upward-pointing triangle that protrudes above the container,
// visually connecting the grid widget to the item above it.
export const StyledTopHandleArrow = styled.div<{ $color: string }>(({ $color }) => ({
    width: 0,
    height: 0,
    borderLeft: "14px solid transparent",
    borderRight: "14px solid transparent",
    borderBottom: `12px solid ${$color}`,
}));
